var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"base-tooltip",class:( _obj = { show: _vm.show, dark: _vm.dark, noWrap: _vm.noWrap }, _obj[_vm.position] = true, _obj )},[_vm._v(_vm._s(_vm.text)),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }